module.exports = __webpack_public_path__ + "img/banner1.54904972.jpg";